import React from 'react';
import { Link } from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';

import { asset } from "Services/BaseHelpers";

const debugEnabled = false;

export default class Dashboard extends React.Component {
    render () {
        return (
            <Authenticated title="Dashboard">
                <div className="relative">
                    <img src={asset("images/home-page.png")} />

{/*
                    <Link
                        to="/settings/profile"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 193,
                            left: 0,
                            width: 155,
                            height: 40,
                        }}
                    />
*/}

                    <Link
                        to="/main-stage"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 121,
                            left: 6,
                            width: 141,
                            height: 65,
                        }}
                    />

                    <Link
                        to="/on-demand"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 79,
                            left: 177,
                            width: 203,
                            height: 58,
                        }}
                    />

                    <Link
                        to="/main-stage/test-stream"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 0,
                            left: 332,
                            width: 174,
                            height: 58,
                        }}
                    />

                    <Link
                        to="/speakers"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 20,
                            left: 597,
                            width: 167,
                            height: 63,
                        }}
                    />

                    <Link
                        to="/agenda"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 122,
                            left: 721,
                            width: 156,
                            height: 59,
                        }}
                    />

                    <Link
                        to="/celebration-wall"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 81,
                            left: 904,
                            width: 274,
                            height: 64,
                        }}
                    />

                    <Link
                        to="/profile"
                        className={`${debugEnabled && "bg-white opacity-50"} absolute`}
                        style={{
                            top: 194,
                            left: 1010,
                            width: 167,
                            height: 64,
                        }}
                    />
                </div>
            </Authenticated>
        );
    }
}
